import { type ReactNode } from 'react';
import { BODY, Bullet, PullQuote, Section } from './rules-typography';

export function GameDynamics(): ReactNode {
  return (
    <Section title="Dinámica del juego">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>Solo puedes ver las fotos de los jugadores del equipo.</Bullet>
        <Bullet>
          Descubres a otros jugadores cuando encuentras un creador ya registrado
          por ellos (lo verás desde la cuenta @the3333games).
        </Bullet>
        <Bullet>
          Te descubren cuando ellos encuentran creadores que tú ya registraste.
        </Bullet>
      </ul>
      <p className={BODY}>Es un juego de exploración + competición.</p>
    </Section>
  );
}

export function TimeLimit(): ReactNode {
  return (
    <Section title="Tiempo limitado">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>
          Duración del juego:{' '}
          <strong className="text-text-primary">30 días</strong>.
        </Bullet>
        <Bullet>Máximo: 60 días si hiciera falta.</Bullet>
      </ul>
      <p className={BODY}>
        No es infinito. El que más se mueve ahora, más gana.
      </p>
    </Section>
  );
}

export function ClosingTruth(): ReactNode {
  return (
    <Section title="La clave real">
      <p className={BODY}>
        Esto no va de probar. Va de{' '}
        <strong className="text-text-primary">
          disciplina diaria + volumen + calidad
        </strong>
        .
      </p>
      <PullQuote>
        Si haces lo mínimo, sobrevives. Si haces lo máximo, ganas dinero real.
        Puedes generar fácilmente $2.500 con 4h al día — pero depende 100% de
        ti.
      </PullQuote>
    </Section>
  );
}
